<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';
import { buildTextareaClass } from './textareaClass';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  defaultValue?: string | number;
  modelValue?: string | number;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});

const root = ref<HTMLTextAreaElement | null>(null);

defineExpose({
  root,
});
</script>

<template>
  <textarea ref="root" v-model="modelValue" :class="buildTextareaClass(props.class)" />
</template>
